module.exports = __webpack_public_path__ + "static/media/3-iveco-mercedes.92dc5831.jpg";